import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserPlus, User, Mail, Lock, AlertCircle, CheckCircle } from 'lucide-react';
import './Register.css';

const Register = () => {
  const [userData, setUserData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    full_name: '',
    is_admin: false
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const { register, isAdmin, canManageUsers, user } = useAuth();
  const navigate = useNavigate();

  // Admin geral ou diretor de grupo
  if (!canManageUsers) {
    navigate('/atendimento');
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validações
    if (userData.password !== userData.confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }

    if (userData.password.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }

    setLoading(true);

    const result = await register({
      username: userData.username,
      email: userData.email,
      password: userData.password,
      full_name: userData.full_name,
      is_admin: userData.is_admin
    });

    if (result.success) {
      setSuccess(`Usuário ${userData.username} criado com sucesso!`);
      setUserData({
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        full_name: '',
        is_admin: false
      });
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUserData({
      ...userData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  return (
    <div className="container">
      {/* Header da página igual ao Dashboard */}
      <div className="register-header">
        <h1 className="register-page-title">Cadastrar Usuário</h1>
        <p className="register-page-subtitle">Criar novo usuário do sistema</p>
      </div>

      <div className="register-card">

        <form onSubmit={handleSubmit} className="register-form">
          {error && (
            <div className="register-error-message">
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          {success && (
            <div className="register-success-message">
              <CheckCircle size={16} />
              {success}
            </div>
          )}

          <div className="register-form-row">
            <div className="register-form-group">
              <label htmlFor="username">Usuário *</label>
              <div className="register-input-group">
                <User size={18} className="register-input-icon" />
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={userData.username}
                  onChange={handleChange}
                  placeholder="Nome de usuário"
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="register-form-group">
              <label htmlFor="email">Email *</label>
              <div className="register-input-group">
                <Mail size={18} className="register-input-icon" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={userData.email}
                  onChange={handleChange}
                  placeholder="email@exemplo.com"
                  required
                  disabled={loading}
                />
              </div>
            </div>
          </div>

          <div className="register-form-group">
            <label htmlFor="full_name">Nome Completo</label>
            <div className="register-input-group">
              <User size={18} className="register-input-icon" />
              <input
                type="text"
                id="full_name"
                name="full_name"
                value={userData.full_name}
                onChange={handleChange}
                placeholder="Nome completo do usuário"
                disabled={loading}
              />
            </div>
          </div>

          <div className="register-form-row">
            <div className="register-form-group">
              <label htmlFor="password">Senha *</label>
              <div className="register-input-group">
                <Lock size={18} className="register-input-icon" />
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={userData.password}
                  onChange={handleChange}
                  placeholder="Mínimo 6 caracteres"
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="register-form-group">
              <label htmlFor="confirmPassword">Confirmar Senha *</label>
              <div className="register-input-group">
                <Lock size={18} className="register-input-icon" />
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={userData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirme a senha"
                  required
                  disabled={loading}
                />
              </div>
            </div>
          </div>

          {isAdmin && (
          <div className="register-form-group">
            <div className="register-checkbox-group">
              <input
                type="checkbox"
                id="is_admin"
                name="is_admin"
                checked={userData.is_admin}
                onChange={handleChange}
                disabled={loading}
              />
              <label htmlFor="is_admin" className="register-checkbox-label">
                Administrador geral
              </label>
            </div>
            <p className="register-checkbox-help">
              Administradores gerais têm acesso total ao sistema
            </p>
          </div>
          )}

          <div className="register-form-actions">
            <button
              type="button"
              className="register-cancel-button"
              onClick={() => navigate('/')}
              disabled={loading}
            >
              Cancelar
            </button>
            
            <button
              type="submit"
              className="register-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="register-loading-spinner"></div>
                  Criando...
                </>
              ) : (
                <>
                  <UserPlus size={18} />
                  Criar Usuário
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
